export const environment = {
  production: true,
  baseUrl: 'https://expert-report-generator-api-test.cloud.vste.cz/api',
  version: '2026-07-07'
};
